import React, { PureComponent, Fragment } from 'react';
import { Link } from 'formlabs-web-components/Link';
import { Grid, Cell } from 'formlabs-web-components/Grid';

import './HeaderMenu.module.css';
import { withTranslation } from 'react-i18next';

class DescriptionDropdown extends PureComponent {
  state = {
    selected: 0
  };

  menuClose = () => {
    this.props.handleHoverMenuClose();
    this.hoverSubMenu(0);
  };

  hoverSubMenu = selected => {
    this.setState({ selected });
  };

  render() {
    const { hoverOptions, dropdownOpen, data, t } = this.props;
    const { selected } = this.state;
    const { children } = data[hoverOptions];
    return (
      <Fragment>
        {children.length >= 1 && (
          <Fragment>
            <nav
              styleName={`dropdown description-dropdown open-${dropdownOpen}`}
              aria-label={t('Show dropdown menu')}
            >
              <div styleName="top-grey-border">
                <Grid direction="x" primaryAlignment="">
                  <Cell mediumSize={11}>
                    <div styleName="content-left">
                      <Grid direction="x">
                        <Cell mediumSize={10} largeSize={10}>
                          <div styleName="description-secondary fade-img fade-0">
                            {children.map((child, i) => {
                              return child.visible ? (
                                <Link
                                  to={child.url}
                                  styleName={`dropdown-left ${
                                    selected === i ? 'selected-secondary' : ''
                                  }`}
                                  key={i}
                                  openInNewWindow={child.newWindow}
                                  onMouseEnter={() => this.hoverSubMenu(i)}
                                >
                                  <div>
                                    <span>{child.name} </span>
                                    {selected === i && (
                                      <span>
                                        <i className="fl-navigate_next" />
                                      </span>
                                    )}
                                  </div>
                                </Link>
                              ) : null;
                            })}
                          </div>
                        </Cell>
                        <Cell mediumSize={2}>
                          <div styleName="menu-divide fade-img fade-0" />
                        </Cell>
                        <Cell
                          mediumSize={10}
                          largeSize={10}
                          mediumOffset={1}
                          largeOffset={1}
                        >
                          {children[selected] && (
                            <div
                              styleName="description-secondary fade-img fade-1"
                              dangerouslySetInnerHTML={{
                                __html: children[selected].description
                              }}
                            />
                          )}
                        </Cell>
                      </Grid>
                    </div>
                  </Cell>
                  <Cell mediumSize={12} mediumOffset={1}>
                    <div
                      styleName="menu-image fade-img fade-2"
                      style={{
                        backgroundImage: `url(${children[selected].image})`
                      }}
                    />
                  </Cell>
                </Grid>
              </div>
            </nav>
            <div
              styleName={`overlay open-${dropdownOpen}`}
              onMouseEnter={this.menuClose}
            />
          </Fragment>
        )}
        {!children && (
          <Fragment>
            <div styleName={`dropdown open-false`} />
            <div
              styleName={`overlay overlay-clear open-false`}
              onMouseEnter={this.menuClose}
            />
          </Fragment>
        )}
      </Fragment>
    );
  }
}
export default withTranslation()(DescriptionDropdown);
